import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { profileResolver } from './features/profile/profile.resolver';
import { BlankComponent } from './layouts/blank/blank.component';
import { CustomComponent } from './layouts/custom/custom.component';

const routes: Routes = [
  {
    path: '',
    component: CustomComponent,
    resolve: {
      dataProfile: profileResolver,
    },
    children: [
      {
        path: '',
        redirectTo: 'app',
        pathMatch: 'full',
      },
      {
        path: 'app',
        loadChildren: () =>
          import('./features/features.module').then((i) => i.FeaturesModule),
      },
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () =>
          import('./pages/authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
      },
      {
        path: 'landingpage',
        loadChildren: () =>
          import('./pages/theme-pages/landingpage/landingpage.module').then(
            (m) => m.LandingPageModule
          ),
      },
      {
        path: 'origin-form',
        loadChildren: () =>
          import('./pages/origin-form-page/origin-form-page.module').then(
            (m) => m.OriginFormPageModule
          ),
      },
    ],
  },
  //{
  //  path: '**',
  //  redirectTo: 'authentication/error',
  //},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
